import React, { useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import apiConfig from '../apiConfig';

const Transfer = () => {
  // Token
  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("add"); // "add" | "subtract"
  const [inpval, setINP] = useState({
    user_id: "",
    amount: "",
    s_key: "",
  });

  const setdata = (e) => {
    const { name, value } = e.target;
    setINP((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const addinpdata = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const { user_id, amount, s_key } = inpval;

    console.log("Sending:", userInfo, "Mode:", mode);

    const endpoint =
      mode === "add"
        ? "/api/balance/add"
        : "/api/balance/deduct";

    const res = await fetch(`${apiConfig.baseURL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id,
        amount,
        s_key,
      }),
    });

    const data = await res.json();
    setIsLoading(false);

    if (res.status === 200) {
      alert(mode === "add" ? "Balance Added Successfully" : "Balance Subtracted Successfully");
      history.push("/agent-balance-report");
    } else {
      if (res.status === 404) {
        alert("This User does not exist");
      } else if (res.status === 422) {
        alert("Not Available Money");
      } else if (res.status === 400) {
        alert("Incorrect Security T-PIN");
      } else {
        console.log("Unhandled error:", res.status, data);
      }
    }
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Balance Transfer</h4>
                <Link to="/agent-balance-report">
                  <button type="button" className="btn btn-success float-right">
                    Report
                  </button>
                </Link>
              </div>
              <div className="card-body">

                {/* Nav Tabs: Add / Subtract */}
                <ul className="nav nav-tabs mb-4">
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${mode === "add" ? "active" : ""}`}
                      onClick={() => setMode("add")}
                    >
                      + Add
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${mode === "subtract" ? "active" : ""}`}
                      onClick={() => setMode("subtract")}
                    >
                      − Subtract
                    </button>
                  </li>
                </ul>

                <div className="basic-form">
                  <form onSubmit={addinpdata}>
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">User Id</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="user_id"
                          className="form-control"
                          placeholder="User Id"
                          onChange={setdata}
                          value={inpval.user_id}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Amount</label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          name="amount"
                          className="form-control"
                          placeholder="Amount"
                          onChange={setdata}
                          value={inpval.amount}
                          min={0}
                          step={1}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Security Key</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          name="s_key"
                          required
                          className="form-control"
                          placeholder="Security Key"
                          onChange={setdata}
                          value={inpval.s_key}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-sm-10">
                        <button
                          type="submit"
                          name="send"
                          className={`btn ${mode === "add" ? "btn-primary" : "btn-danger"}`}
                          disabled={isLoading}
                        >
                          {isLoading
                            ? "Processing..."
                            : mode === "add"
                            ? "+ Add Balance"
                            : "− Subtract Balance"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Transfer;